<template>
  <div class="redirect">
    <div class="gradient-panel">
      <sfi-divider>
        <span class="center step-text">{{ findYourBillTitle }}</span>
      </sfi-divider>

      <div class="content-area">
        <!-- Layout when an image is shown -->
        <div class="grid-x" v-if="hasImage">
          <div class="cell small-12 medium-8">
            <h2 id="redirectTitle">{{ redirectTitle }}</h2>
            <div id="redirectMessage">{{ redirectMessage }}</div>
            <button :name="redirectButtonAnalyticsName"
              id="redirectButton"
              @click="redirectBtn"
              class="button primary-orange fixed flex-child-auto expanded-for-small-only">
              {{ redirectButton }}
          </button>
          </div>
          <div class="cell hide-for-small-only medium-4">
            <img src="@/assets/flamingos-rule.svg" />
          </div>
        </div>
        <!-- Layout when an image is not shown -->
        <div class="grid-x" v-else>
          <div class="cell small-12 variable-height">
            <h2 id="redirectTitle">{{ redirectTitle }}</h2>
            <div id="redirectMessage">
              {{ redirectMessage }}
              <div id="redirectNote">
                <a :name="redirectButtonAnalyticsName" @click="redirectBtn">{{ redirectButton }}</a>
                {{ redirectNote }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Strings
import strings from '@/i18n/en/strings';

// Utilities
import _ from 'lodash';

// Constants
import constants from '@/i18n/en/constants';

// Services
import AnalyticsService from '@/services/AnalyticsService';

export default {
  name: 'redirect-page',
  data() {
    return {
      analyticsConstants: constants.analyticsConstants,
      findYourBillTitle: strings.findYourBill.titlePage,
      redirectStrings: strings.redirect,
      redirectType: this.$store.state.redirect
    }
  },
  created() {
    if (this.redirectType === null || this.redirectType === undefined || this.redirectType === '') {
      this.redirectToPage('find-your-bill');
    }
    window.scrollTo(0, 0);
  },
  mounted() {
    if (this.redirectType === 'specialtyLinesPolicy') {
      AnalyticsService.trackPageView(this.analyticsConstants.SPECIALITY_ERROR);
    }
  },
  computed: {
    hasImage() {
      return this.redirectType === 'specialtyLinesPolicy' || this.redirectType === 'floridaPolicy';
    },
    redirectTitle() {
      return _.get(this.redirectStrings, [this.redirectType, 'title'], '');
    },
    redirectMessage() {
      return _.get(this.redirectStrings, [this.redirectType, 'message'], '');
    },
    redirectNote() {
      return _.get(this.redirectStrings, [this.redirectType, 'note'], '');
    },
    redirectButton() {
      return _.get(this.redirectStrings, [this.redirectType, 'button'], '');
    },
    redirectButtonAnalyticsName() {
      if (this.redirectType === 'floridaPolicy') {
        return this.analyticsConstants.redirectPage.PAYMENT_CENTER;
      }
      return '';
    }
  },
  methods: {
    redirectBtn() {
      this.$store.commit('RESET_STATE');
      if (this.redirectType === 'floridaPolicy') {
        window.location = 'http://www.securityfirstflorida.com/customers/payment-center';
      } else if (this.redirectType === 'missouriPolicy') {
        window.location = 'https://dev-pay.securityfirstmanagers.com/';
      } else {
        this.goToPage('find-your-bill');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variables.scss';

.redirect {
  button {
    margin-top: 1rem;
  }
}
.variable-height {
  min-height: 300px;

  @include breakpoint(small only) {
    min-height: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RedirectPage.vue